<script setup>
  import { computed, onMounted, ref } from 'vue'
  import { useScroll } from '@vueuse/core'

  const { y } = useScroll(window)

  const noHero = ref(false)
  const hasScrolled = computed(() => {
    if (y.value > 0) return true
  })

  onMounted(() => {
    const sections = document.querySelectorAll('section')
    if (!sections.length) return false
    noHero.value = !sections[0].classList.contains('element-hero')
  })


</script>

<template>
  <div
    class="header-inner transition-colors duration-500 z-[100] w-full h-auto fixed top-0 left-0 border-b border-white/30"
    :class="hasScrolled || noHero ? 'bg-white shadow-md' : 'bg-transparent'"
  >
    <div
      class="max-w-screen-2xl w-full mx-auto px-6 grid grid-cols-2 lg:grid-cols-3 items-center"
    >
      <slot
        name="menu"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
  :deep(.header-logo svg) {
    @apply ~h-7/9 w-auto;
  }
  :deep(nav a) {
    @apply text-white transition-all duration-500 relative;
    &::after {
      content: '';
      position: absolute;
      bottom: -6px;
      left: 0;
      right: 0;
      margin: 0 auto;
      height: 1px;
      width: 0;
      background: #C83528;
      transition: width 0.5s ease-in-out;
    }
    &::before {
      content: '';
      position: absolute;
      bottom: -6px;
      left: 0;
      right: 0;
      margin: 0 auto;
      height: 1px;
      width: 0%;
      background: #C83528;
      transition: width 0.5s ease-in-out;
    }
    &:hover {
      @apply text-primary;
      &::after {
        width: 100%;
      }
      &::before {
        width: 100%;
      }
    }
  }

  .header-inner.bg-white {
    :deep(a) {
      @apply text-black;
      &:hover {
        @apply text-primary;
      }
    }
    :deep(.header-logo svg path) {
      fill: #C83528 !important;
    }
    :deep(button) {
      @apply border-border;
      span {
        @apply bg-black;
      }
    }
  }

</style>

